/**
 * Kill switch for the seat-inventory-exceeded alerts: scenario/period/day/interval icons, cell and
 * row highlights, daily-chart bands, the seats-alert details dialog and the advisory lock warning.
 * Turned off for the 2026-08-22 production release while the accuracy bugs are outstanding —
 * flip to true to restore the feature. The Excel-export equivalent is
 * SEAT_EXCEEDED_HIGHLIGHT_ENABLED in report-api's report/seat_capacity.py.
 */
export var SEAT_CAPACITY_ALERTS_ENABLED = false;
export var isSeatCapacityAlertsEnabled = function () {
  return SEAT_CAPACITY_ALERTS_ENABLED;
};